"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";

interface VestraTokenProps {
  /** Pixel size (width & height). Default 24. */
  size?: number;
  className?: string;
}

export function VestraToken({ size = 24, className }: VestraTokenProps) {
  return (
    <Image
      src="/assets/vestra-credits.svg"
      alt="Vestra credits"
      width={size}
      height={size}
      className={cn("flex-shrink-0", className)}
    />
  );
}
